import * as React from "react";
import {Field, reduxForm, InjectedFormProps} from 'redux-form'

import {Action, Dispatch} from "redux";
import {connect} from "react-redux";
import * as Validator from "../../../../../util/validation";

import {AppState} from "../../../../store/app_state";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import {clientConfig} from "../../../../../config/language/ja-JP/domain/model_text";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import ErrorText from "../../../../common/atom/text/error_text";

const validate = (values: any) => {
    const errors: any = {};
    return errors
};

interface IProps extends InjectedFormProps<FormData, {}> {
}

interface IState {
}

export class ClientClientsCreateForm extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {};

    };

    public render(): JSX.Element {
        const {
            invalid,
            handleSubmit,
            pristine,
            submitting,
            error} = this.props;

        // デバッグ用ログ
        if (error) {
            console.log('=== ClientClientsCreateForm Error Debug ===');
            console.log('error:', error);
            console.log('typeof error:', typeof error);
            console.log('error.toString():', error.toString ? error.toString() : 'no toString method');
            console.log('String(error):', String(error));
            console.log('includes("409"):', String(error).includes("409"));
            console.log('includes("AlreadyExists"):', String(error).includes("AlreadyExists"));
        }

        return (
            <React.Fragment>

                <form
                    name="ClientClientsCreateForm"
                    onSubmit={handleSubmit}>

                    <FormFieldWrapper>
                        <Field
                            label={clientConfig.name}
                            placeholder="山田　太郎"
                            name="name"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.clientName, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ={clientConfig.nameKana}
                            placeholder="やまだ　たろう"
                            name="nameKana"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.clientNameKana, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ="電話番号"
                            placeholder="080xxxxxxxx（ハイフンなし）"
                            name="phoneNumber"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.required, Validator.phoneNumber]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ="役職"
                            placeholder="役職"
                            name="position"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.title, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label="メールアドレス"
                            placeholder="メールアドレス"
                            name="email"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.email, Validator.emailCount, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <FormFieldWrapper>
                        <Field
                            label ="パスワード"
                            placeholder="パスワード"
                            name="password"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.password, Validator.passwordCount, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>

                    {error && (
                        <SubmitErrorTextWrapper>
                            <ErrorText>
                                {String(error).includes("409")
                                    ? "このメールアドレスは既に登録されています。"
                                    : error}
                            </ErrorText>
                        </SubmitErrorTextWrapper>
                    )}

                    <SubmitButtonWrapper>
                        <CancelButtonWrapper><BtnLinkCancelSmall to="/client/clients">キャンセル</BtnLinkCancelSmall></CancelButtonWrapper>
                        <BtnCorporateLarge
                            name="ClientCreateForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting || invalid}>追加する</BtnCorporateLarge>
                    </SubmitButtonWrapper>

                </form>
            </React.Fragment>
        )
    };
}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
        form: 'ClientClientsCreateForm',
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(ClientClientsCreateForm));



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/create/client_clients_create_form.tsx